import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Caret = forwardRef<SVGSVGElement, IconProps>(
  ({ size, color, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M13 6L8 11L3 6L13 6Z" fill={color || 'currentColor'} />
    </svg>
  ),
)
Caret.displayName = 'Caret'

export default Caret
